<template>
  <div class="basicssetup">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>文本与协议管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-loading="isRefresh">
      <div class="main">
        <h4>文本与协议管理</h4>
        <div class="upbg">
          <el-form :model="ruleFormPT"
                   :rules="rulesPT"
                   ref="ruleFormPT"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-row>
              <el-col :span="11"
                      style="margin-right:10px;">
                <el-form-item label="普通用户称谓:"
                              prop="userTitle">
                  <el-input v-model="ruleFormPT.userTitle"
                            placeholder="选填，2-10个字"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="认证用户称谓:"
                              prop="photoUserTitle">
                  <el-input v-model="ruleFormPT.photoUserTitle"
                            placeholder="选填，2-10个字"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </div>
      </div>

      <!-- <div class="main">
        <h4>网站信息管理</h4>
        <div class="upbg">
          <el-form :model="ruleFormWeb"
                   :rules="rulesWeb"
                   ref="ruleFormWeb"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-row>
              <el-col :span="11"
                      style="margin-right:10px;">
                <el-form-item label="网站标题:"
                              prop="webTitle">
                  <el-input v-model="ruleFormWeb.webTitle"
                            placeholder="请填写网站标题"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="网站关键词:"
                              prop="webKeywords">
                  <el-input v-model="ruleFormWeb.webKeywords"
                            placeholder="请填写网站关键词"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="11"
                      style="margin-right:10px;">
                <el-form-item label="网站摘要:" prop="webDescription">
                  <el-input v-model="ruleFormWeb.webDescription"
                            placeholder="请填写网站摘要"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="网站徽标:">
                  <el-upload class="upload-demo"
                             action="#"
                             :show-file-list="false"
                             :auto-upload="false"
                             :on-change="onChange">
                    <div v-if="!logoFile"
                         style="font-size:12px;color:#185ED3;">+ 上传图片</div>
                  </el-upload>

                  <div v-if="logoFile"
                       class="imgbj">
                    <el-image lazy
                              class="imgs"
                              :src="logoFile.src"
                              :preview-src-list="[logoFile.src]"></el-image>
                    <p @click.stop="deleteLogoFile"
                       class="delete">删除</p>

                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <div class="main"
           style="padding-top:0px;">
        <h4>底部版权信息</h4>
        <div class="upbg"
             style="padding:0px;height:300px;">
          <el-input v-model="ruleFormPT.copyRight"
                    style="width:100%;height:100%;"
                    placeholder="请填写底部版权信息"
                            type="textarea"></el-input>
        </div>
      </div> -->

      <div class="main"
           style="padding-top:0px;">
        <h4>用户注册协议
          <span @click="clearEdior('reg')"
                :style="{'color': isSimple ? '#E27B02' : '#194897'}">一键清空</span>
        </h4>
        <div class="upbg"
             style="padding:0px;">
          <div id="websiteEditorElemreg"
               style="height:340px;background: #ffffff;"></div>
        </div>
      </div>

      <div class="main"
           style="padding-top:0px;margin-top:60px;">
        <h4>用户认证协议
          <span @click="clearEdior('auth')"
                :style="{'color': isSimple ? '#E27B02' : '#194897'}">一键清空</span>
        </h4>
        <div class="upbg"
             style="padding:0px;">
          <div id="websiteEditorElemauth"
               style="height:340px;background: #ffffff;"></div>
        </div>
      </div>
      <div class="main"
           style="padding-top:0px;margin-top:40px;">
        <h4>投稿分类</h4>
        <div>
          <el-input v-model="ruleFormPT.articleTags"
                    style="width:100%;"
                    placeholder="请填写投稿分类清单 （例如：科技|教育|文化）"
                    :autosize="{ minRows: 12, maxRows: 14}"
                    type="textarea"></el-input>
        </div>
      </div>

      <div class="main"
           style="padding-top:0px;margin-top:40px;">
        <h4>摄影师协会清单</h4>
        <div>
          <el-input v-model="ruleFormPT.photographersAssociation"
                    style="width:100%;"
                    placeholder="请填写摄影师协会清单清单 （例如：中国摄影协会|江苏摄影协会）"
                    :autosize="{ minRows: 12, maxRows: 14}"
                    type="textarea"></el-input>
        </div>
      </div>

      <div class="main"
           style="padding-top:0px;margin-bottom:100px;margin-top:40px;">
        <h4>摄影师协会职务清单</h4>
        <div>
          <el-input v-model="ruleFormPT.photographersAssociationJobs"
                    style="width:100%;"
                    placeholder="请填写摄影师协会职务清单清单 （例如：名誉主席|主席|副主席）"
                    :autosize="{ minRows: 12, maxRows: 14}"
                    type="textarea"></el-input>
        </div>
      </div>

    </div>

    <div class="bottombtn">
      <div class="btn">
        <!-- <el-button :disabled="isRefresh" @click="closeForm">取消</el-button> -->
        <el-button :disabled="isRefresh"
                   @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
import E from "wangeditor";
import getMD5 from "@/plugins/getMD5";
import SparkMD5 from "spark-md5";
import { picPrefix } from "@/constants/piccommon";
import { setAppTextConfig, getAppTextConfig } from "@/api/config";

export default {
  components: {

  },
  data () {
    return {
      picPrefix,
      phoneEditorReg: '',
      phoneEditorAuth: '',

      reg: '',
      auth: '',
      ruleFormPTFlag: false,
      ruleFormPT: {
        userTitle: '',
        photoUserTitle: '',
        // sensitiveWords: '',
        copyRight: '',
        articleTags:'',
        photographersAssociation :'',
        photographersAssociationJobs :'',
      },
      ruleFormWeb: {
        webDescription: '',
        webKeywords: '',
        webTitle: '',
        webIcon: '',

        
      },
      rulesPT: {
        userTitle: [
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        photoUserTitle: [
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
      },
      rulesWeb: {
        // userTitle: [
        //   { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        // ],
        // photoUserTitle: [
        //   { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        // ],
      },

      //网站徽标
      logoFile: null,


      isRefresh: false,

    };
  },
  methods: {

    handleCheckAllChange (val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    //刷新表格
    refresh () {

      this.isRefresh = true
      this.getAppTextConfigAsync();
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },

    clearEdior (name) {
      this.$confirm("确认清空吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          if (name == 'auth') {
            this.phoneEditorAuth.txt.clear()
          } else {
            this.phoneEditorReg.txt.clear()
          }
        })
        .catch(e => {
          // console.log("取消", i);
        });

    },


    closeForm () {
      this.$message('正在开发中……')
    },

    //上传网站徽标
    onChange (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)

      this.uploadPicAsyncLogo(file, 1)
    },

    deleteLogoFile () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.logoFile = null
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },

    //直接上传
    async uploadPicAsyncLogo (val, flag) {
      var paramData = new FormData();
      paramData.append("file", val.raw);
      let { status, data, message } = await uploadPic(paramData);
      if (status) {
        if (flag === 1) {
          this.logoFile = val
          this.logoFile.src = picPrefix + data.savepath
        }
      }
    },




    submitForm () {
      // console.log(this.phoneEditorReg.txt.html())
      if (
        this.phoneEditorReg.txt.html() &&
        this.ruleFormPT.photoUserTitle &&
        this.phoneEditorAuth.txt.html() &&
        this.ruleFormPT.userTitle
        // this.ruleFormPT.copyRight &&
        // this.ruleFormWeb.webDescription &&
        // this.ruleFormWeb.webKeywords &&
        // this.ruleFormWeb.webTitle &&
        // this.logoFile
      ) {
        let data = {
          photoUserRegAgreement: this.phoneEditorReg.txt.html(),
          photoUserTitle: this.ruleFormPT.photoUserTitle,
          userRegAgreement: this.phoneEditorAuth.txt.html(),
          userTitle: this.ruleFormPT.userTitle,
          articleTags : this.ruleFormPT.articleTags,
          photographersAssociation : this.ruleFormPT.photographersAssociation,
          photographersAssociationJobs : this.ruleFormPT.photographersAssociationJobs,
          // copyRight: this.ruleFormPT.copyRight,
          // webDescription: this.ruleFormWeb.webDescription,
          // webKeywords: this.ruleFormWeb.webKeywords,
          // webTitle: this.ruleFormWeb.webTitle,
          // webIcon: this.logoFile ? this.logoFile.src : null,
        }
        this.setAppTextConfigAsync(data)
      } else {
        this.$message.error('请填写内容！')
      }




    },

    //分片上传
    fragmentation (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          this.uploadPicChunkAsync(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          this.uploadPicChunkMergeAsync(params, blob, insert);
        }
        start = end;
        index++;
      }
    },

    //常规文件上传
    async uploadPicAsync (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        if (insert === 1) {
          this.thumbnailFile = val;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        } else {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditorAuth.txt.html(this.phoneEditorAuth.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          this.phoneEditorReg.txt.html(this.phoneEditorReg.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        }
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsync (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditorAuth.txt.html(this.phoneEditorAuth.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          this.phoneEditorReg.txt.html(this.phoneEditorReg.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          // console.log(this.phoneEditor.txt.html().substring(this.phoneEditor.txt.html().indexOf('el-icon-loading') - 10,this.phoneEditor.txt.html().indexOf('el-icon-loading') + 21))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }
      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsync (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentation(val, blob, b, t, insert);
      } else {
        if (insert !== 1) {
          let src = picPrefix + data.savepath;
          insert(src);
          this.phoneEditorAuth.txt.html(this.phoneEditorAuth.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
          this.phoneEditorReg.txt.html(this.phoneEditorReg.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
        } else {
          this.thumbnailFile = blob;
          this.thumbnailFile.src = picPrefix + data.savepath;
          this.thumbnailFile.themePicture = data.savepath;
          this.isFile = false
        }

      }
    },


    //获取配置
    async getAppTextConfigAsync () {
      this.isRefresh = true
      let { status, data, message, errors } = await getAppTextConfig();
      if (status) {
        if (data.userTitle) {
          this.ruleFormPT.userTitle = data.userTitle
        }
        if (data.photoUserTitle) {
          this.ruleFormPT.photoUserTitle = data.photoUserTitle
        }
        // if (data.copyRight) {
        //   this.ruleFormPT.copyRight = data.copyRight
        // }
        // if (data.webTitle) {
        //   this.ruleFormWeb.webTitle = data.webTitle
        // }
        // if (data.webKeywords) {
        //   this.ruleFormWeb.webKeywords = data.webKeywords
        // }
        // if (data.webDescription) {
        //   this.ruleFormWeb.webDescription = data.webDescription
        // }

        // if (data.webIcon === null) {
        //   this.logoFile = null
        // } else {
        //   this.logoFile = {
        //     src: data.webIcon
        //   }
        // }


        if (data.photoUserRegAgreement) {
          this.phoneEditorReg.txt.html(data.photoUserRegAgreement)
        }
        if (data.userRegAgreement) {
          this.phoneEditorAuth.txt.html(data.userRegAgreement)
        }

        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },
    //设置配置
    async setAppTextConfigAsync (val) {
      let { status, data, message, errors } = await setAppTextConfig(val);
      if (status) {
        this.$message.success('设置成功！');
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

  },
  created () {
    this.getAppTextConfigAsync()
  },
  mounted () {
    var that = this;
    this.phoneEditorReg = new E("#websiteEditorElemreg");
    this.phoneEditorAuth = new E("#websiteEditorElemauth");

    this.phoneEditorReg.customConfig.showLinkImg = false;

    // 自定义菜单配置
    this.phoneEditorReg.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      // 'link',  // 插入链接
      // 'list',  // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "image", // 插入图片
      // 'table',  // 表格
      // 'video',  // 插入视频
      // 'code',  // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];

    // 将图片大小限制为 50M
    this.phoneEditorReg.customConfig.uploadImgMaxSize = 50 * 1024 * 1024;

    // 限制一次最多上传 10 张图片
    this.phoneEditorReg.customConfig.uploadImgMaxLength = 10;
    //上传图片事件
    this.phoneEditorReg.customConfig.customUploadImg = function (files, insert) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      let icon = '<i style="font-size:24px" class="el-icon-loading"></i>'
      that.phoneEditorReg.txt.html(that.phoneEditorReg.txt.html() + icon)

      files.forEach(item => {

        if (item.size > 560000) {
          bytesPerPiece = 202020;
        } else {
          bytesPerPiece = 9888;
        }
        getMD5(item, md5 => {
          that.getFileInfoByHashAsync(
            md5,
            item,
            bytesPerPiece,
            totalPieces,
            insert
          );
        });

      });
    };

    // 创建一个富文本编辑器
    this.phoneEditorReg.create();
    // 富文本内容
    this.phoneEditorReg.txt.html(this.reg);




    this.phoneEditorAuth.customConfig.showLinkImg = false;

    // 自定义菜单配置
    this.phoneEditorAuth.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      // 'link',  // 插入链接
      // 'list',  // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "image", // 插入图片
      // 'table',  // 表格
      // 'video',  // 插入视频
      // 'code',  // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];

    // 将图片大小限制为 50M
    this.phoneEditorAuth.customConfig.uploadImgMaxSize = 50 * 1024 * 1024;

    // 限制一次最多上传 10 张图片
    this.phoneEditorAuth.customConfig.uploadImgMaxLength = 10;
    //上传图片事件
    this.phoneEditorAuth.customConfig.customUploadImg = function (files, insert) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;
      let icon = '<i style="font-size:24px" class="el-icon-loading"></i>'
      that.phoneEditorAuth.txt.html(that.phoneEditorAuth.txt.html() + icon)

      files.forEach(item => {

        if (item.size > 560000) {
          bytesPerPiece = 202020;
        } else {
          bytesPerPiece = 9888;
        }
        getMD5(item, md5 => {
          that.getFileInfoByHashAsync(
            md5,
            item,
            bytesPerPiece,
            totalPieces,
            insert
          );
        });

      });
    };

    // 创建一个富文本编辑器
    this.phoneEditorAuth.create();
    // 富文本内容
    this.phoneEditorAuth.txt.html(this.auth);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./textagreementmanage.scss";

h4 {
  font-size: 18px;
}
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 0;
  // top: 0;
  z-index: 5;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn ::v-deep .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary {
  background-color: #185ed3;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}

::v-deep .el-loading-mask {
  z-index: 2;
}
::v-deep .el-icon-circle-close {
  margin-top: 150px;
}
.upbg ::v-deep .w-e-text-container {
  z-index: 3 !important;
}
.upbg ::v-deep .w-e-menu {
  z-index: 5 !important;
}
.upbg ::v-deep .w-e-droplist {
  z-index: 100000 !important;
}
</style>
